exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.hidden[data-v-cd6098e0] {\n    display: none;\n}\n\n", ""]);

// exports
